import { render, staticRenderFns } from "./fleeingDetail.vue?vue&type=template&id=cd012902&scoped=true"
import script from "./fleeingDetail.vue?vue&type=script&lang=js"
export * from "./fleeingDetail.vue?vue&type=script&lang=js"
import style0 from "./fleeingDetail.vue?vue&type=style&index=0&id=cd012902&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd012902",
  null
  
)

export default component.exports